import { createAction } from '@reduxjs/toolkit';
import { SET_AMBASSADOR_DETAILS_DATA, SET_INITIAL_AMBASSADOR_DETAILS_DATA } from './actionTypes';
export const setAmbassadorDetailsData = createAction(SET_AMBASSADOR_DETAILS_DATA);
export const setInitialAmbassadorDetailsData = createAction(SET_INITIAL_AMBASSADOR_DETAILS_DATA);
export const actions = {
    setAmbassadorDetailsData,
    setInitialAmbassadorDetailsData,
};
